import { useState, useEffect } from "react";
import { fetchTrendingGames } from "../../services/api";
import "./TrendingGames.css";

const FALLBACK = [
  { _id: "f1", title: "Game 1", rating: 4.8, image: "/x.png" },
  { _id: "f2", title: "Game 2", rating: 4.3, image: "/project_05.jpg" },
  { _id: "f3", title: "Game 3", rating: 4.5, image: "/RG5.jpg" },
  { _id: "f4", title: "Game 4", rating: 4.1, image: "/RG2.jpg" },
];

export default function TrendingGames() {
  const [games, setGames] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTrendingGames()
      .then((data) => { if (data && data.length) setGames(data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="trending-section section" id="trending">
      <div className="container">
        <div className="trending-header reveal">
          <h2 className="section-title" style={{ marginBottom: 0 }}>
            Trending Games Right Now
          </h2>
          <a href="#" className="btn-outline">SEE ALL</a>
        </div>

        <div className="games-grid">
          {games.map((game, i) => (
            <div
              key={game._id}
              className={`game-card reveal ${loading ? "skeleton" : ""}`}
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <div className="game-thumb">
                <img 
                  src={game.image || game.imageUrl} 
                  alt={game.title || `Trending Game ${i + 1}`}
                  className="game-thumb-img"
                  loading="lazy"
                />
              </div>
              <div className="game-info">
                <span className="game-fire">🔥</span>
                <span className="game-rating-text">{game.rating}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
